
















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";
import moment from "moment";
import _ from "lodash";
import Add from "./settlement_items_detail_add.vue";
import Edit from "./settlement_items_detail_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;
  @Prop() itemId!: number;

  dispatchType: string = "stadium/settlementItemsDetailList";
  deleteConfirmContent: string = "确定要删除该记录吗？";
  dispatchTypeDelete: string = "stadium/settlementItemsDetailDelete";

  columns: any[] = [
    { title: "类型", scopedSlots: { customRender: "item_type" } },
    // { title: "项目代码", dataIndex: "item_code" },
    // { title: "开始时间", scopedSlots: { customRender: "start_time" }  },
    // { title: "结束时间", scopedSlots: { customRender: "end_time" } },
    { title: "次数", scopedSlots:{customRender:"count"}  },
    { title: "关联订单", dataIndex: "ref_ids" },
    { title: "总额", scopedSlots:{customRender:"total"} },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  getValue(obj: any, path: any) {
    let result = _.get(obj, path);
    // console.log(result)
    if (_.isUndefined(result) || result === "0" || result === 0 || result ==null) {
      result = '';
    } else {
      result = moment(result*1000).format('YYYY-MM-DD');
    }
    return result;
  }
  
  getTotal(obj:any){
    if(obj.total<=0){
      return ""
    }
    const v=obj.total/100;
    return v+'元(月初)'
  }

  getCount(obj:any){
    if(obj.count<=0){
      return ""
    }
    return obj.count
  }

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
        item_id: this.itemId
      },
      false
    );
  }
}
